import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

import { FesBaseComponent } from '../../../shared/components/fes-base.component';
import { AppState } from '../../../core';
import { ScheduleComment } from '../../../core/models';
import { PathTestService, ScoutTaskService, TaskService } from '../../../core/services';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ConfirmModalComponent } from '../../../shared/components/confirm-modal/confirm-modal.component';
import { ScoutTaskDoc } from '../../../core/schema/scout-task-schema';
import { PathTestDoc } from '../../../core/schema/path-test-schema';
import { Observable } from 'rxjs';
import { v4 as uuidv4 } from 'uuid'

@Component({
  selector: 'app-task-schedule-comments',
  templateUrl: './task-schedule-comments.component.html',
  styleUrls: ['./task-schedule-comments.component.scss']
})
export class TaskScheduleCommentsComponent extends FesBaseComponent implements OnInit, OnDestroy {

  @Input('taskDoc') set taskDocSetter( taskDoc: PathTestDoc | ScoutTaskDoc ) {
    this.currentTaskId = taskDoc._id
    this.taskDoc = taskDoc
    this.initDocScheduleComments()
  }

  taskDoc : PathTestDoc | ScoutTaskDoc
  comments$ : Observable<ScheduleComment[]>
  
  currentTaskId : string
  comment = new FormControl('');

  someCommentsDeleted = false
  isEditing = false
  isSaving = false
  showDeleted = false

  constructor(
    appState: AppState,
    protected taskService: TaskService,
    protected scoutTaskService: ScoutTaskService,
    protected pathTestService: PathTestService,
    protected modalService: BsModalService
  ) {
    super(appState)
    this.comment.setValidators(Validators.required)
  }

  ngOnInit(): void {
    this.updateState()
  }

  initDocScheduleComments() {
    if ( !this.taskDoc ) {
      return
    }
    const comments = this.taskDoc.schedule?.scheduleComments
    if ( !comments ) {
      console.warn("task comments null or undefined")
      this.taskDoc.atomicUpdate( (scoutTask) => {
        if ( !scoutTask.schedule ) {
          scoutTask.schedule = {}
        }
        scoutTask.schedule.scheduleComments = []
        return scoutTask
      })
    } else if ( comments.some( comment => !comment.id ) ) {
      console.warn("task comment(s) missing id (adding unique id)")
      this.taskDoc.atomicUpdate( (scoutTask) => {
        for ( const comment of scoutTask.schedule.scheduleComments ) {
          if ( !comment.id ) {
            comment.id = uuidv4()
          }
        }
        return scoutTask
      })
    }
    this.comments$ = this.taskDoc.get$('schedule.scheduleComments')
  }

  ngOnDestroy(): void {
    this.destroy()
  }


  isModified = () => {
    return this.isEditing && this.comment?.valid // zero length invalid
  }

  async askDiscardEdits(acceptDiscardFn: () => void) {
    let initialState = {
      onYes: acceptDiscardFn,
      question: 'Discard unsaved schedule comments?',
      focusOnNo: true,
      yesStyle: 'btn btn-danger'
    }
    this.modalService.config.animated = false
    this.modalService.show(ConfirmModalComponent, { initialState });
  }


  updateState() {
    this.someCommentsDeleted = this.taskDoc?.schedule?.scheduleComments?.some(c => c.archived)
  }

  async onSaveComment() {
    this.isSaving = true
    try {
      this.isEditing = false
      await this.taskDoc.atomicUpdate((taskDoc) => {
        let comment = new ScheduleComment()
        comment.timestamp = this.taskService.nowTimeStamp(),
          comment.archived = false
        comment.text = this.comment.value
        comment.userId = this.appState.getUser()._id
        taskDoc.schedule.scheduleComments.push(comment)
        return taskDoc
      })
      this.comment.setValue('')
    } catch (error) {
      this.isEditing = true
      this.taskService.publishError(error, this)
      return false
    } finally {
      this.updateState()
      this.isSaving = false;
    }
  }

  onCancelComment(): void {
    this.isEditing = false
    this.comment.setValue('')
  }

  sortComments() {
    console.log('sortComments()')
  }

  async archive(comment:ScheduleComment, bArchive: boolean) {
    console.log(`archive(comment:${comment.id},bArchive:${bArchive})`)
    console.dir(comment)
    this.isSaving = true
    try {
      const updatedDoc = await this.taskDoc.atomicUpdate((task) => {
        const comments: ScheduleComment[] = task.schedule?.scheduleComments;
        console.log(comments?.length)
        let targetComment = comments.find(c=>c.id == comment.id)
        if ( comment ) {
          targetComment.archived = bArchive
        } else {
          this.taskService.publishError(`Could not set archive=${bArchive} because comment not found by id ${comment.id}`,this)
        }
        return task
      })
      this.taskService.publishSuccess((bArchive ? 'Deleted' : 'Restored') + ' comment', this)
      return true
    } catch (error) {
      console.error(error)
      this.taskService.publishError(error, this)
      return false
    } finally {
      this.updateState()
      this.isSaving = false;
    }
  }

  showDeletedChecked(val: any) {
    this.showDeleted = val
  }

}
